import { useContext, useState } from "react"
import { UserContext } from "./contexts"
import ReferralModal from "./ReferralModal"
import * as Iconoir from "iconoir-react"

const ReferralBanner = () => {
  const user = useContext(UserContext)
  const [showModal, setShowModal] = useState(false)

  if (user.plan !== "freemium") {
    return null
  }

  return (
    <>
      <div
        className="p-3 mt-4 bg-purple-50 border border-purple-200 rounded-lg text-center cursor-pointer hover:bg-purple-100 transition-colors"
        onClick={() => setShowModal(true)}
      >
        <div className="flex items-center justify-center gap-2">
          <Iconoir.Gift className="w-5 h-5 text-purple-600" />
          <h3 className="font-semibold text-sm text-purple-800">Love Vibrato?</h3>
        </div>
        <p className="text-xs mt-1 text-purple-700">Refer a friend and get 60 extra minutes!</p>
      </div>
      <ReferralModal show={showModal} onClose={() => setShowModal(false)} />
    </>
  )
}

export default ReferralBanner
